export const factureStatus = (status) => {
  switch (status) {
    case "-1":
      return "لغو شده";
    case "0":
      return "پرداخت نشده";
    case "1":
      return "پرداخت شده";
    default:
      break;
  }
};
